import { QuestionWithRelations } from "../../../../../api/src/types";
import {
  MissingAnswerMessageContainer,
  QuestionOptionsListContainer,
} from "./components";
import { StyledErrorMessage, StyledOptionContainer } from "./components";
import { IconSize } from "../../../components/theme";
import Checkbox from "../../../components/icons/Checkbox";
import { ParagraphSmall } from "../../../components/typography/Paragraph";

interface ReadOnlyDropdownProps {
  question: QuestionWithRelations;
  missingAnswerMessage: string;
}

const ReadOnlyDropdown: React.FC<ReadOnlyDropdownProps> = ({
  question,
  missingAnswerMessage,
}) => {
  const selectedOptionId =
    question.answers[0]?.answerQuestionOptions[0]?.questionOptionId;
  const selectedOption = question.questionOptions.find(
    (option) => option.id === selectedOptionId,
  );
  if (!selectedOption) {
    return (
      <MissingAnswerMessageContainer>
        <StyledErrorMessage>{missingAnswerMessage}</StyledErrorMessage>
      </MissingAnswerMessageContainer>
    );
  }
  return (
    <QuestionOptionsListContainer data-testid="read-only-dropdown">
      <StyledOptionContainer isChecked={true}>
        <Checkbox isChecked={true} size={IconSize.M} />
        <ParagraphSmall fontWeight={300} textAlign="left">
          <span dangerouslySetInnerHTML={{ __html: selectedOption.value }} />
        </ParagraphSmall>
      </StyledOptionContainer>
    </QuestionOptionsListContainer>
  );
};

export default ReadOnlyDropdown;
